import { render } from "./WaitingRoomOverlay.vue?vue&type=template&id=299c5a2c&scoped=true&ts=true"
import script from "./WaitingRoomOverlay.vue?vue&type=script&lang=ts"
export * from "./WaitingRoomOverlay.vue?vue&type=script&lang=ts"

import "./WaitingRoomOverlay.vue?vue&type=style&index=0&id=299c5a2c&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299c5a2c"]])

export default __exports__